import styled from 'styled-components'

export const ErrorMessageStyles = styled.p`
font-size: 14px;
font-weight: 400;
line-height: 16px;
color: #fa8484;
margin-top: 3px;
`
